__turbopack_context__.v({
  "card": "PostCard-module-scss-module__aGjTgW__card",
  "cardContent": "PostCard-module-scss-module__aGjTgW__cardContent",
  "postContent": "PostCard-module-scss-module__aGjTgW__postContent",
  "textContent": "PostCard-module-scss-module__aGjTgW__textContent",
  "title": "PostCard-module-scss-module__aGjTgW__title",
});
